import { QueryClient } from '@tanstack/react-query';

import { isAPIError } from '../network/types';
import { ToastManager } from '../toast/utils';

export const DEFAULT_GC_TIME = 5 * 60 * 1000; // 5 minutes

export const silentQueryErrorHandler = (error: unknown) => queryErrorHandler(error, true);

export const queryErrorHandler = (error: unknown, silent?: boolean) => {
  if (isAPIError(error)) {
    const { message } = error;

    if (!silent) {
      ToastManager.show({ message, severity: 'error' });
    }
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      gcTime: DEFAULT_GC_TIME,
    },
    mutations: {
      onError: (error: unknown) => queryErrorHandler(error, false),
    },
  },
});
